<template>
  <div class="edit-project-form">
    <el-dialog
      :title="readonly ? 'View Project' : 'Edit Project'"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :width="device === 'mobile' ? '80%' : '50%'"
    >
      <el-form
        :model="projectForm"
        id="projectForm"
        ref="projectForm"
        label-width="200px"
        size="small"
        :rules="projectFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-form-item label="Distribution code" prop="distribution_code">
          <el-input
            v-model="projectForm.distribution_code"
            autocomplete="off"
            readonly="readonly"
          ></el-input>
        </el-form-item>
        <el-form-item label="Prefix code" prop="prefix_code">
          <el-input
            v-model="projectForm.prefix_code"
            autocomplete="off"
            :readonly="readonly"
          ></el-input>
        </el-form-item>
        <el-form-item label="Project Name" prop="project_name">
          <el-input
            v-model="projectForm.project_name"
            autocomplete="off"
            :readonly="readonly"
          ></el-input>
        </el-form-item>
        <el-form-item label="Discription" prop="discription">
          <el-input
            type="textarea"
            :rows="2"
            v-model="projectForm.discription"
            :readonly="readonly"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Pricing control by" prop="pricingby">
          <el-select
            v-model="projectForm.pricingby"
            placeholder="Select Pricing control"
            :disabled="readonly"
          >
            <el-option label="ABBS" value="abbs"></el-option>
            <el-option label="Data System" value="ds"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Fee Control By" prop="feeby">
          <el-select
            v-model="projectForm.feeby"
            placeholder="Select Fee Control By"
            :disabled="readonly"
          >
            <el-option label="ABBS" value="abbs"></el-option>
            <el-option label="Data System" value="ds"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Webhook bank" prop="webhook_bank">
          <el-input
            v-model="projectForm.webhook_bank"
            :readonly="readonly"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook bank key" prop="webhook_bank_key">
          <el-input
            v-model="projectForm.webhook_bank_key"
            :readonly="readonly"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook transaction" prop="webhook_transaction">
          <el-input
            v-model="projectForm.webhook_transaction"
            :readonly="readonly"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="Webhook transaction key"
          prop="webhook_transaction_key"
        >
          <el-input
            v-model="projectForm.webhook_transaction_key"
            :readonly="readonly"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="Account Limit By Currency"
          prop="accountLimitBycurrency"
        >
          <el-input
            v-model="projectForm.accountLimitBycurrency"
            :readonly="readonly"
          ></el-input>
        </el-form-item>

        <el-form-item label="User Role">
          <el-checkbox-group v-model="projectForm.user" :disabled="readonly">
            <el-checkbox
              v-for="item in userData"
              :label="item.uid"
              :key="item.uid"
              >{{ `${item.role} - ${item.email}` }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!readonly">
        <el-button :loading="submiting" type="primary" @click="submitProject()"
          >Submit</el-button
        >
        <el-button @click="handleClose">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateProject } from "@/api/project";
import { getUserByCompany } from "@/api/user";
export default {
  props: {
    dialogShow: Boolean,
    companyUID: String,
    formData: Object
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    readonly() {
      return this.roleAuth([this.role.admin]);
    }
  },
  data() {
    return {
      submiting: false,
      errMsg: "",
      userData: [],
      projectForm: {
        uid: "",
        project_name: "",
        distribution_code: "",
        prefix_code: "",
        discription: "",
        pricingby: "abbs",
        feeby: "abbs",
        webhook_bank: "",
        webhook_bank_key: "",
        webhook_transaction: "",
        webhook_transaction_key: "",
        accountLimitBycurrency: "",
        user: []
      },
      projectFormRules: {
        project_name: [
          {
            required: true,
            message: "Please enter Project Name",
            trigger: "blur"
          }
        ],
        prefix_code: [
          {
            required: true,
            message: "Please enter prefix code",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getUserByCompanyData() {
      getUserByCompany(this.companyUID).then(({ result, data }) => {
        if (result) {
          this.userData = data;
          this.projectForm.uid = this.formData.uid;
          this.projectForm.project_name = this.formData.project_name;
          this.projectForm.distribution_code = this.formData.distribution_code;
          this.projectForm.prefix_code = this.formData.prefix_code;
          this.projectForm.discription = this.formData.discription;
          this.projectForm.pricingby = this.formData.pricingby;
          this.projectForm.feeby = this.formData.feeby;
          this.projectForm.user = this.formData.project_user_role;

          this.projectForm.webhook_bank = this.formData.webhook_bank;
          this.projectForm.webhook_bank_key = this.formData.webhook_bank_key;
          this.projectForm.webhook_transaction = this.formData.webhook_transaction;
          this.projectForm.webhook_transaction_key = this.formData.webhook_transaction_key;
          this.projectForm.accountLimitBycurrency = this.formData.accountLimitBycurrency;
        }
      });
    },

    mapData() {
      const formData = {
        project_name: this.projectForm.project_name,
        discription: this.projectForm.discription,
        pricingby: this.projectForm.pricingby,
        feeby: this.projectForm.feeby,
        prefix_code: this.projectForm.prefix_code,
        user_uid: this.projectForm.user.join(","),
        webhook_bank: this.projectForm.webhook_bank,
        webhook_bank_key: this.projectForm.webhook_bank_key,
        webhook_transaction: this.projectForm.webhook_transaction,
        webhook_transaction_key: this.projectForm.webhook_transaction_key,
        accountLimitBycurrency:
          parseInt(this.projectForm.accountLimitBycurrency) || 0
      };
      return formData;
    },
    updateProject() {
      const formData = this.mapData();
      this.submiting = true;
      this.errMsg = "";
      updateProject(this.projectForm.uid, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Project successfully`,
              type: "success",
              duration: 2000
            });
            this.handleClose();
            this.$emit("on-submited", true);
          } else {
            this.errMsg = message;
          }
        }
      );
    },
    submitProject() {
      this.$refs.projectForm.validate(valid => {
        if (valid) {
          this.updateProject();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      if (this.$refs.projectForm) this.$refs.projectForm.resetFields();
    },
    handleClose() {
      this.$emit("update:dialog-show", false);
    }
  },
  created() {
    this.getUserByCompanyData();
  }
};
</script>

<style></style>

